import { walletApiSlice } from '../apiSlice';

interface IInititatePaymentRequest {
	walletId: string;
	amountNaira: number;
	gateway: number;
	createdByUserId: string;
	expirationDuration?: string;
	couponCode: string | null;
}

interface IInititatePaymentResponse {
	paymentIntentId: string;
	walletId: string;
	tenantId: string;
	amountNaira: number;
	expectedCredits: number;
	conversionRateUsed: number;
	gateway: string;
	status: number;
	clientReference: string;
	createdByUserId: string;
	createdAt: string;
	expiresAt: string;
	paymentUrl: string;
}

export interface IVerifyPaymentResponse {
	isVerified: boolean;
	gatewayStatus: string;
	gatewayMessage: string;
	rawResponse: string | null;
	paymentIntentId: string;
	walletId: string;
	expectedCredits: number;
	creditsApplied: number;
	originalAmount: number;
}

const paymentApiSlice = walletApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		initiatePayment: builder.mutation<IInititatePaymentResponse, IInititatePaymentRequest>({
			query: (body) => ({
				url: '/payments/initialize',
				method: 'POST',
				body,
			}),
		}),
		verifyPayment: builder.mutation<IVerifyPaymentResponse, { reference: string }>({
			query: (body) => ({
				url: '/payments/verify',
				method: 'POST',
				body,
			}),
			invalidatesTags: ['WalletBalance'],
		}),
	}),
});

export const { useInitiatePaymentMutation, useVerifyPaymentMutation } = paymentApiSlice;
